//
// Generated class ArchivedDocument
//

/// <reference path="ArchivedDocument_ManagedObject.ts" />

class ArchivedDocument extends ArchivedDocument_ManagedObject
{
}
